import { Component } from '@angular/core';

@Component({
  selector: 'ws-site-home',
  templateUrl: './home.component.html'
})
export class SiteHomeComponent {}
